export default __webpack_public_path__ + "static/media/geometry-artwork-6.94033f2b.webp";